import React, { useState, useEffect, useMemo, ChangeEvent } from 'react';
import { Widget, MasterDetailForm, Table } from '@digital/ui';
import { ContratadoOverHeadAnual, RequisitadoAno, atualizarValorContratadoAnoTipoOverHead, ContratadoOverHead } from '@app/api/projeto';
import { Collapse, Icon, InputNumber } from 'antd';
import { Distribuicao, ContratadoAnoTipoOverHead } from '@app/api/ctrPcs';
import CurrencyInput from '@app/components/CurrencyInput';
import { CreateUpdateCrfContratadoTipoOverHeadByContaContabilCc, UpdateCrfContratadoOverHead } from '@app/api/crf/crfContrato';
import CurrencyInput2 from '@app/components/CurrencyInput2';
import { currencyFormat, currencyFormatSemAbreviacao, formatCurrencyBr, transformFloat } from '@app/helpers/numbers';

interface FormResumoContratadoProps {
  contratadoOverHeadAnual: ContratadoOverHeadAnual;
  style: any;
  atualizaContratadoTipoOverHead(id: any): void;
  updateContratadoOverHeadAnual?: (crfContaContabilCcId: string) => void;
}

const { Panel } = Collapse;

const FormTableContratadoOverheadAnual = (
  { contratadoOverHeadAnual,
    style,
    atualizaContratadoTipoOverHead,
    updateContratadoOverHeadAnual,
  }: FormResumoContratadoProps) => {

  const [distribuicaoItemSelecionado, setdistribuicaoItemSelecionado] = useState<string>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [distribuicao, setDistribuicao] = useState<Distribuicao>();
  const [resultOverHead, setOverHead] = useState<RequisitadoAno[]>();

  const [novoValorTipoOverHead, setNovoValorTipoOverHead] = useState<number>(0);

  const colunaOI = 10
  const colunaPacotePctOi = 200
  const colunaNome = 250
  const colunaAno = 170;

  useEffect(() => {
    const getData = async () => {
      if (contratadoOverHeadAnual) {
        console.log(contratadoOverHeadAnual, 'teste')
        setOverHead(contratadoOverHeadAnual.resultDataTabel);
        setDistribuicao(contratadoOverHeadAnual);
        if (contratadoOverHeadAnual)
          if (contratadoOverHeadAnual.resultDataTabel) {
            let contratado = contratadoOverHeadAnual.resultDataTabel[0];
            if (contratado) {
              setdistribuicaoItemSelecionado(contratado.numero);
            }
          }
      }
    };

    getData();
  }, [contratadoOverHeadAnual]);



  const columsTabela = () => {
    const colluns = [];
    colluns.push(
      {
        title: 'Conta Contábil',
        dataIndex: 'codigoContaContabil',
        width: colunaOI
      },
      {
        title: 'Código Agrupador',
        dataIndex: 'codigoAgrupador',
        width: colunaPacotePctOi
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: colunaNome
      },
      {
        title: 'Valor',
        dataIndex: 'valorCrfContratadoAnoOverHead',
        width: 20,
        render: (text: any, record: ContratadoOverHead, index: any) => {
          return (
            <CurrencyInput2
              id="valorCrfContratadoAnoOverHead"
              name="valorCrfContratadoAnoOverHead"
              value={transformFloat(record.valorCrfContratadoAnoOverHead)}
              onChange={(e) => {
                setNovoValorTipoOverHead(e);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  CreateUpdateCrfContratadoTipoOverHeadByContaContabilCc(
                    record.crfContaContabilCcId,
                    {
                      crfContaContabilCcId: record.crfContaContabilCcId,
                      valor: novoValorTipoOverHead,
                    } as UpdateCrfContratadoOverHead)
                    .then(data => {
                      updateContratadoOverHeadAnual && updateContratadoOverHeadAnual(record.crfContaContabilCcId);
                    })
                }
              }}
            />
          )
        }
      },
    );

    // if (distribuicao && distribuicao.anos) {
    //   const distrubuicao = distribuicao as DistribuicaoRequisitado;

    //   let colunasAnos: {
    //     title: string;
    //     dataIndex: string;
    //     width: number;
    //     children: (
    //       | {
    //         title: string;
    //         dataIndex: string;
    //         key: string;
    //         render: (text: any, record: any, index: any) => JSX.Element;
    //       }
    //       | {
    //         title: string;
    //         dataIndex: string;
    //         key: string;
    //         render?: undefined;
    //       })[];
    //   }[] = [];

    //   distrubuicao.anos.forEach((ano: any) => {

    //     colunasAnos.push({
    //       title: `${ano}`,
    //       dataIndex: `${ano}`,
    //       width: colunaAno,
    //       children: [
    //         {
    //           title: '',
    //           dataIndex: `valorFormatado${ano}`,
    //           key: `valorFormatado${ano}`,
    //           render: (text, record, index) => {
    //             return (
    //               <Input
    //                 id={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
    //                 name={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
    //                 onBlur={() => {
    //                   //cancelar();
    //                 }}
    //                 onPressEnter={e => {
    //                   const evento = (e as unknown) as ChangeEvent<HTMLInputElement>;
    //                   setdistribuicaoItemSelecionado(record[`numero`]);
    //                   salvar(record, evento, record[`valor${ano}`], `${ano}`);
    //                 }}
    //                 defaultValue={record[`valor${ano}`]}
    //                 onChange={e => {
    //                   record[`valor${ano}`] = e.target.value;
    //                 }}
    //               />
    //             );
    //           },
    //         },
    //       ],
    //     });
    //   });
    //   if (colunasAnos.length > 0) {
    //     colluns.push({
    //       title: '',
    //       key: 'RATEIO',
    //       children: colunasAnos,
    //     });
    //   }
    // }

    return colluns;
  };

  const salvar = (
    recorder: ContratadoAnoTipoOverHead,
    event: ChangeEvent<HTMLInputElement>,
    valorAlterado: string,
    ano: string,
  ) => {
    atualizarValorContratadoAnoTipoOverHead(
      recorder.moduloEconomicoContratadoId,
      recorder.ordemInvestimentoId,
      valorAlterado,
      ano,
    ).then(data => {
      atualizaContratadoTipoOverHead(distribuicaoItemSelecionado);
    });
  };

  const larguraTotal = useMemo(() => {

    let larguraColunaAno = 0;
    if (distribuicao && distribuicao.anos != undefined && distribuicao.anos.length > 0) {
      larguraColunaAno = distribuicao.anos.length * colunaAno;
    }

    return (larguraColunaAno + colunaOI + colunaPacotePctOi + colunaNome);
  }, [distribuicao]);


  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="Overhead anual" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget>
              <Table
                rowKey="index"
                scroll={{ x: larguraTotal }}
                columns={columsTabela()}
                id={"tableOverheadAnual"}
                dataSource={resultOverHead || []}
              />
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoOverheadAnual;
